<div class="header">
  <div class="left-logo">
    <img
      src="https://images.ctfassets.net/ippsyns7liau/2Y8e7036FWcEUWqsYMkyKo/e0a9e8d8c9a097e23d57b46a13d43064/RGB_WisdomPanel_TM.png?h=75"/>
  </div>
  <div class="centered-header">
    <h1>
      <app-content-block blockId="adminportal.header.title"></app-content-block>
    </h1>
    <button mat-raised-button color="accent" *ngIf="user && requestedSample.sampleStatusCode === 5" (click)="viewReport()">
      <app-content-block blockId="adminportal.header.viewreportbutton"></app-content-block>
    </button>
  </div>

  <div class="progress-container" *ngIf="user && requestedSample">
    <app-progress [statusCode]="requestedSample.sampleStatusCode"></app-progress>
  </div>
</div>
<div class="admin-content" *ngIf="user && requestedSample">
  <mat-card>
    <mat-card-title class="title-with-button">
      <app-content-block blockId="adminportal.petinformation.title"></app-content-block>

      <button mat-raised-button color="accent" (click)="editPetInfo(user, requestedSample)">
        <app-content-block blockId="adminportal.petinformation.edit"></app-content-block>
        <mat-icon aria-hidden="false" aria-label="Edit Pet Information">edit</mat-icon>
      </button>

    </mat-card-title>
    <mat-card-content>
      <table class="data-table">
        <tr>
          <td>
            <app-content-block blockId="adminportal.petinformation.petname"></app-content-block>
          </td>
          <td>{{requestedSample.petDetails.name}}</td>
        </tr>
        <tr>
          <td>
            <app-content-block blockId="adminportal.petinformation.petgender"></app-content-block>
          </td>
          <td>{{requestedSample.petDetails.gender | titlecase}}</td>
        </tr>
        <tr>
          <td>
            <app-content-block blockId="adminportal.petinformation.ownername"></app-content-block>
          </td>
          <td>{{user.firstName}} {{user.lastName}}</td>
        </tr>
        <tr>
          <td>
            <app-content-block blockId="adminportal.petinformation.owneremail"></app-content-block>
          </td>
          <td>{{user.email}}</td>
        </tr>
        <tr>
          <td>
            <app-content-block blockId="adminportal.petinformation.hospitalnumber"></app-content-block>
          </td>
          <td>{{requestedSample.clinicCode}}</td>
        </tr>
        <tr>
          <td>
            <app-content-block blockId="adminportal.petinformation.petid"></app-content-block>
          </td>
          <td>{{requestedSample.petDetails.banfieldPetId}}</td>
        </tr>
        <tr>
          <td>
            <app-content-block blockId="adminportal.petinformation.ownerid"></app-content-block>
          </td>
          <td>{{user.externalId}}</td>
        </tr>
      </table>

    </mat-card-content>

    <mat-card-title>
      <app-content-block blockId="adminportal.sampleinformation.title"></app-content-block>
    </mat-card-title>
    <mat-card-content>
      <table class="data-table">
        <tr>
          <td>
            <app-content-block blockId="adminportal.sampleinformation.sampleid"></app-content-block>
          </td>
          <td>{{requestedSample.sampleId}}</td>
        </tr>
        <tr>
          <td>
            <app-content-block blockId="adminportal.sampleinformation.antechnumber"></app-content-block>
          </td>
          <td>{{requestedSample.antechAccessionNo}}</td>
        </tr>
      </table>
    </mat-card-content>

    <mat-card-title>
      <app-content-block blockId="adminportal.samplehistory.title"></app-content-block>
    </mat-card-title>
    <mat-card-content *ngIf="requestedSample">
      <app-sample-history-table [sampleHistory]="requestedSample.sampleStatusHistory"></app-sample-history-table>

      <button mat-raised-button color="accent" (click)="showContactDialog()">
        <app-content-block blockId="adminportal.contact.button"></app-content-block>
      </button>
    </mat-card-content>
  </mat-card>
</div>
